import { setSuccessMessage, setErrorMessage } from 'apps/notifications/actions/notifications';
import { config } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';

export const ADD_TO_FAVOURITES = 'ADD_TO_FAVOURITES';
export const REMOVE_FROM_FAVOURITES = 'REMOVE_FROM_FAVOURITES';

function addSkuToFavourites(sku) {
  return {
    type: ADD_TO_FAVOURITES,
    sku,
  };
}

function removeSkuFromFavourites(sku) {
  return {
    type: REMOVE_FROM_FAVOURITES,
    sku,
  };
}

export function addToFavourites(sku) {
  return (dispatch, getState, { network, loginWatcher }) =>
    loginWatcher.subscribe(getState)
      .then(() => {
        dispatch(addSkuToFavourites(sku));
        return network
          .patch(`${config.apiBasePath}/favourites`, {
            body: JSON.stringify([sku]),
          })
          .then(() => {
            dispatch(setSuccessMessage('The product has been <b>added to your favourites</b>'));
          })
          .catch(err => {
            const { message } = err.data || {};
            dispatch(removeSkuFromFavourites(sku));
            dispatch(setErrorMessage(message || UNKNOWN_ERROR.error));
          });
      });
}

export function removeFromFavourites(sku) {
  return (dispatch, getState, { network }) => {
    dispatch(removeSkuFromFavourites(sku));
    return network
      .del(`${config.apiBasePath}/favourites`, {
        body: JSON.stringify([sku]),
      })
      .then(() => {
        dispatch(setSuccessMessage('The product has been <b>removed from your favourites</b>'));
      })
      .catch(err => {
        const { message } = err.data || {};
        dispatch(addSkuToFavourites(sku));
        dispatch(setErrorMessage(message || UNKNOWN_ERROR.error));
      });
  };
}
